import React from 'react';
import useTheme from 'branding/theme';
import getIconColor from '../../getIconColor';
const UserIcon = ({ type = 'utility', size = 'regular', disabled = false, styles, ...rest }) => {
    const { colors, sizing } = useTheme();
    const color = getIconColor(colors, type, disabled);
    const sizePx = sizing.widths.icon[size];
    return (React.createElement("svg", { viewBox: "0 0 40 36", width: sizePx, height: sizePx, style: styles, ...rest },
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("g", { strokeWidth: "2", stroke: color, strokeLinecap: "round" },
                React.createElement("path", { d: "M25.831 21.443l2.28 1.33c9.178 5.236 10.319 10.512 10.46 11.79" }),
                React.createElement("path", { d: "M8.004 25.195c-3.785 2.64-6.07 6.972-6.865 9.66h30.174", strokeLinejoin: "round" }),
                React.createElement("path", { d: "M19.888 23.7c-5.394 0-9.765-4.89-9.765-10.925 0-6.035 4.37-10.926 9.765-10.926 5.394 0 9.765 4.891 9.765 10.926 0 3.53-1.498 6.673-3.82 8.67" })))));
};
export default UserIcon;
//# sourceMappingURL=index.js.map